import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '@core';
import { FileDetails, fileParms } from '@core/services/file-processing/file-processing.model';
import { FileProcessingService } from '@core/services/file-processing/file-processing.service';
import { process } from '@progress/kendo-data-query';
import { GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';
import * as FileSaver from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseComponent } from '../base/base.component';
import { forkJoin } from 'rxjs';
import { DescriptionModel } from '@core/services/base.model';
import { Client } from '../../core/services/client/client.model';
import { AuthService } from '../../core/services/auth/auth.service';
import { ClientService } from '../../core/services/client/client.service';
import { Router } from '@angular/router';
import { UserService } from '../../core/services/user/user.service';

@Component({
  selector: 'Teranet-DownloadInputFiles',
  templateUrl: './download-input-files.component.html',
})
export class DownloadInputFilesComponent extends BaseComponent {
  downloadFileName: string = '';
  downloadInputFileForm: FormGroup;
  fileList: FileDetails[] = [];
  fileParms: fileParms;
  fileTypes: DescriptionModel[] = [];
  gridSettings: GridSettings;
  isHideGrid: boolean;
  services: any;
  clientInfos: Client[] = [];

  constructor(
    private fileProcessingService: FileProcessingService,
    private spinner: NgxSpinnerService,
    private settingsService: SettingsService,
    private authService: AuthService,
    private clientService: ClientService,
    private router: Router,
    private userService: UserService

  ) {
    super(settingsService);
    let today = new Date();
    this.downloadInputFileForm = new FormGroup(
      {
        fromDate: new FormControl(
          new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
          Validators.required
        ),
        toDate: new FormControl(new Date(), Validators.required),
        clientId: new FormControl('', Validators.required),
        fileTypeId: new FormControl('', Validators.required),
      },
      { validators: this.dateRangeValidator() }
    );
  }

  public state: any = {
    skip: 0,
    take: 13,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  ngOnInit() {
    this.isHideGrid = true;
    this.gridSettings = this.GridDefaultSettings();
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 1 seconds */
      this.spinner.hide();
      this.refesh();
    }, 1000);
  }

  dateRangeValidator() {
    return (form: FormGroup) => {
      const fromDate = form.get('fromDate');
      const toDate = form.get('toDate');
      const miniVal =
        (toDate.errors == null ||
          (toDate.errors != null &&
            toDate.errors.pattern == undefined &&
            toDate.errors.required == undefined)) &&
        fromDate.value > toDate.value
          ? { min: fromDate.value }
          : null;
      const fromDateExistedErrors =
        fromDate.errors != null &&
        (fromDate.errors.pattern != undefined || fromDate.errors.required != undefined)
          ? fromDate.errors
          : null;
      if (miniVal || fromDateExistedErrors) {
        form.get('fromDate').setErrors({ ...fromDateExistedErrors, ...miniVal });
      } else {
        form.get('fromDate').setErrors(null);
      }
      const toDateExistedErrors =
        toDate.errors != null &&
        (toDate.errors.pattern != undefined || toDate.errors.required != undefined)
          ? toDate.errors
          : null;
      if (miniVal || toDateExistedErrors) {
        form.get('toDate').setErrors({ ...toDateExistedErrors, ...miniVal });
      } else {
        form.get('toDate').setErrors(null);
      }

      return miniVal;
    };
  }

  downloadFile(row: any, services: any) {
    if (row && this.services) {
      let fileProcessingService =
        this.services && this.services[0]
          ? this.services[0]
          : this != null
          ? this.fileProcessingService
          : null;
      let spinner =
        this.services && this.services[1] ? this.services[1] : this != null ? this.spinner : null;

      if (spinner) {
        spinner.show();
      }
      this.downloadFileName = row.documentDescription;
      if (fileProcessingService) {
        fileProcessingService.downloadFile(row.documentId).subscribe(response => {
          if (response) {
            const blob = new Blob([response.body], { type: response.headers.get('content-type') });
            this.downloadFileName =
              this.downloadFileName || response.headers.get('content-disposition').split(';')[0];
            const file = new File([blob], this.downloadFileName, {
              type: response.headers.get('content-type'),
            });
            FileSaver.saveAs(file);
          }
          if (spinner) {
            spinner.hide();
          }
        });
      } else {
        if (spinner) {
          spinner.hide();
        }
      }
    }
  }

  getFileListRefresh() {
    setTimeout(() => {
      if (this.fileList.length >= 0) {
        this.spinner.hide();
      } else {
        this.getFileListRefresh();
      }
    }, 500);
  }

  getFiles() {
    this.fileProcessingService.getAllFiles(this.fileParms).subscribe(data => {
      if (data) {
        this.fileList = data;
      }
      this.isHideGrid = false;
    });
  }

  lookup() {
    if (this.downloadInputFileForm.valid) {
      this.fileParms = {
        endTime: this.downloadInputFileForm.get('toDate').value,
        fileTypeId: this.downloadInputFileForm.get('fileTypeId').value,
        files: [],
        clientInfoId: this.downloadInputFileForm.get('clientId').value,
        startTime: this.downloadInputFileForm.get('fromDate').value,
        type: 1,
      };
      this.spinner.show();
      this.fileList = [];
      this.getFiles();
      this.getFileListRefresh();
    }
  }
  onFileTypeChange() {
    this.fileList = [];
    this.isHideGrid = true;
  }

  onFromDateChange() {
    let startTime = this.downloadInputFileForm.get('fromDate').value;
    this.downloadInputFileForm
      .get('fromDate')
      .setValue(
        new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), 0, 0, 0)
      );
  }
  onClientChange() {
    this.fileList = [];
    this.isHideGrid = true;
  }

  onToDateChange() {
    let endTime = this.downloadInputFileForm.get('toDate').value;
    this.downloadInputFileForm
      .get('toDate')
      .setValue(new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate(), 23, 59, 59));
  }
   

  refesh() {
    this.spinner.show();

    


    const getFileTypeDescriptions = this.fileProcessingService.getFileTypeDescriptions();
    const getClientInfo = this.clientService.getAllClients();

    forkJoin([getFileTypeDescriptions, getClientInfo]).subscribe(responses => {
      if (responses[0] != null && responses[0] != undefined) {
        this.fileTypes = responses[0] as DescriptionModel[];
      }
      if (responses[1] != null && responses[1] != undefined) {
        this.clientInfos = responses[1] as Client[];
      }
      this.spinner.hide();
    });
  }

  reset() {
    this.downloadInputFileForm.reset({
      status: '',
    });
    this.fileList = [];
  }

  GridDefaultSettings(): GridSettings {
    return {
      state: this.state,
      gridData: process(this.fileList, this.state),
      columnsConfig: [
        {
          field: 'clientInfoDescription',
          filterable: true,
          hidden: false,
          title: 'Corp Name',
          width: 80,
        },
        {
          field: 'fileTypeName',
          filterable: true,
          hidden: false,
          title: 'File Type',
          width: 100,
        },
        {
          field: 'documentDescription',
          filterable: true,
          includeInChooser: false,
          hidden: false,
          title: 'File Name',
          width: 170,
        },
        {
          field: 'documentCreatedDateUtc',
          filter: 'date',
          filterable: true,
          format: 'yyyy-MM-dd HH:mm:ss',
          hidden: false,
          title: 'Created Time',
          type: 'dateUTC',
          width: 170,
        },
        {
          clickAction: this.downloadFile,
          field: 'documentId',
          filterable: false,
          hidden: false,
          icon: 'download',
          includeInChooser: false,
          title: 'Download',
          type: 'icon',
          services: [this.fileProcessingService, this.spinner],
          width: 40,
        },
      ],
    };
  }
}
